import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { get, map } from 'lodash';
import { gql, useQuery } from '@apollo/client';
import copy from 'copy-to-clipboard';

import './style.scss';
import { AddProduct } from '../../components/productCard';
import { message } from 'antd';

const GET_CART_PRODUCTS = gql`
  query cartProducts($ids: [ID!]!) {
    productList(ids: $ids) {
      id
      name
      price
      promotion
      mainCover {
        id
        url
      }
    }
  }
`;

const selectRecap = (state) => {
  const ids = state.cart.ids;

  return [ids, state.cart.qty];
};

const formatPrice = (price) => {
  if (!price) {
    return null;
  }
  return `${(price / 100).toFixed(2)} €`;
};

export const CartRecap = () => {
  const [productIds, qty] = useSelector(selectRecap);
  const dispatch = useDispatch();
  const { data, loading } = useQuery(GET_CART_PRODUCTS, {
    variables: {
      ids: productIds,
    },
    notifyOnNetworkStatusChange: true,
  });
  const products = get(data, 'productList');

  // Auto clean disabled products
  useEffect(() => {
    if (products && !loading) {
      const missing = productIds.filter((id) => {
        return !products.find((p) => p.id === id);
      });
      missing.forEach((id) => {
        dispatch({ type: 'REMOVE_PRODUCT_ALL', productId: id });
      });
    }
  }, [products, loading]);

  const onCopy = () => {
    const text =
      map(products, (p) => `'${p.name}' X ${qty[p.id] || 0}`).join('\n') + '\n';
    copy(text);

    message.success({
      content:
        'Panier copié ! Vous pouver coller le panier par message facebook !',
    });
  };

  return (
    <div className="app-cart-recap">
      <div className="app-cart-title">Panier</div>
      {map(products, (p) => (
        <div key={p.id} className="app-cart-recap-item">
          {p.mainCover && <img src={p.mainCover.url} alt="product" />}
          {!p.mainCover && <div className="app-cart-recap-item-placeholder" />}
          <div className="app-cart-recap-item-name">{p.name}</div>
          <div>
            <div className="app-cart-recap-item-price">
              {Boolean(p.promotion && p.price) && (
                <span
                  style={{ textDecoration: 'line-through', marginRight: 5 }}
                >
                  {formatPrice(p.price)}
                </span>
              )}
              {Boolean(p.promotion || p.price) &&
                formatPrice(p.promotion || p.price)}
            </div>
            <AddProduct productId={p.id} />
          </div>
        </div>
      ))}
      {productIds.length === 0 && (
        <div className="app-cart-empty">Votre panier est vide</div>
      )}
      <div style={{ flexGrow: 1 }} />
      {productIds.length > 0 && (
        <div className="app-cart-message">
          <div style={{ fontWeight: 'bold' }}>
            Commander au <a href="tel:06 22 98 40 69">06 22 98 40 69</a> ou par
            message via notre page facebook
          </div>
          <div style={{ marginTop: 4 }}>
            Vous pouvez cliquer sur le bouton ci-dessous pour copier le contenu
            de votre panier en tant que message
          </div>
        </div>
      )}
      {productIds.length > 0 && (
        <button className="app-cart-submit" onClick={onCopy}>
          Copier le panier
        </button>
      )}
    </div>
  );
};
